export default {
  data() {
    return {
      categories: [
        { index: 1, title: 'Language' },
        { index: 2, title: 'Mathematics' },
        { index: 3, title: 'Mechanical Reasoning' },
        { index: 4, title: 'Comprehension' },
        { index: 5, title: 'Spatial Reasoning' },
      ],
      
      questions: [
        {
          id: 1,
          categoryId: 1,
          image: null,
          question: 'What does the fox say?',
          choices: [
            'pew',
            'pow',
            'paw',
            'mew',
          ],
          answer: 'pew'
        }
      ],

    }
  },
  methods: {
    choicesToArray(arr) {
      for(let i=0; i<arr.length; i++) {
        arr[i].choices = JSON.parse(arr[i].choices);
      }
      return arr;
    },

  }
}